module.exports = __webpack_public_path__ + "img/location_24px.af54701e.svg";